import { render, staticRenderFns } from "./NuovaAnagrafica.vue?vue&type=template&id=a8f3ed36&"
import script from "./NuovaAnagrafica.vue?vue&type=script&lang=js&"
export * from "./NuovaAnagrafica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports